"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { showPosterPlus: false };
        GState.bind(this, [
            'tenant',
            'theme'
        ]);
    },
    onSelectLogo: function (status) {
        this.state.showPosterPlus = status || false;
    },
    onSetLogo: function ({base64, src}) {
        if (!src)
            return;
        this.state.showPosterPlus = false;
        this.saveChange('logo', base64 || src);
    },
    saveChange: function (name, value) {
        GState.tenant.update({ [name]: typeof value == 'object' && value.target ? value.target.value : value });
    },
    saveSubChange: function (target, name, value) {
        GState.tenant.update({ [name]: typeof value == 'object' && value.target ? value.target.value : value }, target);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Settings/Admin/sections/Account.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_DefaultLogo = require("~/../public/images/default/institution.png"),
    DefaultLogo = module_DefaultLogo.default || module_DefaultLogo,
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Image_template = require("../../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    CountryInput_template = require("../../../../../components/CountryInput/index.marko"),
    CountryInput_tag = marko_loadTag(CountryInput_template),
    PosterPlus_template = require("../../../../../components/PosterPlus/index.marko"),
    PosterPlus_tag = marko_loadTag(PosterPlus_template),
    marko_attrs0 = {
        "class": "font-medium-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("d514c1"),
    marko_node0 = marko_createElement("br", null, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "py-1"
      },
    marko_attrs2 = {
        "class": "py-1"
      },
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_attrs5 = {
        "class": "form-group"
      },
    marko_attrs6 = {
        "class": "form-group"
      },
    marko_attrs7 = {
        "class": "col-md-3 col-4 border-right"
      },
    marko_attrs8 = {
        "class": "col-md-8 col-7 pl-6"
      },
    marko_attrs9 = {
        "class": "btn btn-outline-secondary btn-lg display-inline-block mt-2"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Row_tag({
      col: [
          {
              renderBody: function(out) {
                out.be("p", marko_attrs0, "2", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Change the logo of the institution");
                    }
                  }, out, __component, "3");

                out.ee();

                out.n(marko_node0, component);

                Row_tag({
                    col: [
                        {
                            ns: "col-5",
                            qs: "col-8",
                            hs: "col-12",
                            renderBody: function(out) {
                              out.be("section", marko_attrs1, "7", component);

                              Row_tag({
                                  class: "m-0 d-flex align-items-center",
                                  renderBody: function(out) {
                                    out.be("div", marko_attrs7, "9", component, null, 0, {
                                        onclick: __component.d("click", "onSelectLogo", false)
                                      });

                                    Image_tag({
                                        alt: "Image",
                                        class: "img-fluid round",
                                        src: state.tenant.logo || DefaultLogo
                                      }, out, __component, "10");

                                    out.ee();

                                    out.be("div", marko_attrs8, "11", component);

                                    out.be("button", marko_attrs9, "12", component, null, 0, {
                                        onclick: __component.d("click", "onSelectLogo", false)
                                      });

                                    Locale_tag({
                                        text: "Add/Change Logo"
                                      }, out, __component, "13");

                                    out.ee();

                                    out.ee();
                                  }
                                }, out, __component, "8");

                              out.ee();

                              out.be("section", marko_attrs2, "14", component);

                              out.e("div", marko_attrs3, "15", component, 1)
                                .e("input", {
                                    type: "text",
                                    value: state.tenant.name,
                                    required: true,
                                    "class": "form-control form-control-xl px-2",
                                    placeholder: Locale("Name of the institution")
                                  }, "16", component, 0, 0, {
                                    onchange: __component.d("change", "saveChange", false, [
                                        "name"
                                      ])
                                  });

                              out.e("div", marko_attrs4, "17", component, 1)
                                .e("textarea", {
                                    type: "text",
                                    value: state.tenant.description,
                                    "class": "form-control form-control-xl px-2",
                                    placeholder: Locale("Give us a short description"),
                                    style: marko_styleValue({
                                        height: "100px",
                                        resize: "none"
                                      })
                                  }, "18", component, 0, 0, {
                                    onchange: __component.d("change", "saveChange", false, [
                                        "description"
                                      ])
                                  });

                              out.e("div", marko_attrs5, "19", component, 1)
                                .e("input", {
                                    type: "text",
                                    value: state.tenant.contacts.email,
                                    required: true,
                                    "class": "form-control form-control-xl px-2",
                                    placeholder: Locale("Email Address of your institution"),
                                    validate: "email"
                                  }, "20", component, 0, 0, {
                                    onchange: __component.d("change", "saveSubChange", false, [
                                        "contacts",
                                        "email"
                                      ])
                                  });

                              out.be("div", marko_attrs6, "21", component);

                              CountryInput_tag({
                                  class: "rounded",
                                  size: "xl",
                                  returnLabel: true,
                                  required: true,
                                  value: state.tenant.countries && state.tenant.countries[0],
                                  placeholder: Locale("Location Country")
                                }, out, __component, "22", [
                                [
                                  "change",
                                  "saveChange",
                                  false,
                                  [
                                      "countries"
                                    ]
                                ]
                              ]);

                              out.ee();

                              out.ee();
                            }
                          }
                      ]
                  }, out, __component, "5");
              }
            }
        ]
    }, out, __component, "0");

  if (state.showPosterPlus) {
    PosterPlus_tag({
        width: 480,
        height: 480,
        maxSize: 240,
        accepts: "image/*",
        theme: state.theme.mode
      }, out, __component, "23", [
      [
        "done",
        "onSetLogo",
        false
      ],
      [
        "cancelled",
        "onSelectLogo",
        false,
        [
            false
          ]
      ]
    ]);
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
